export default class RegexBuilder {
    string;
    constructor() {
        this.string = '^';
    }
    plusMinus() {
        this.string += '[-+]?';
        return this;
    }
    decimalNumber() {
        this.string += '\\d+(\\.\\d+)?';
        return this;
    }
    integer(digits) {
        this.string += `\\d${digits ? `{${digits}}` : '+'}`;
        return this;
    }
    comma() {
        this.string += ',?\\s*';
        return this;
    }
    degreeOption() {
        this.string += '(°|° | )';
        return this;
    }
    minuteOption() {
        this.string += `'?`;
        return this;
    }
    secondOption() {
        this.string += `"?`;
        return this;
    }
    whiteSpace() {
        this.string += '\\s*';
        return this;
    }
    ns() {
        this.string += '[NS]';
        return this;
    }
    ew() {
        this.string += '[EW]';
        return this;
    }
    with(string) {
        this.string += string;
        return this;
    }
    build() {
        this.string += '$';
        return new RegExp(this.string);
    }
}
//# sourceMappingURL=RegexBuilder.js.map